import { layouts } from 'chart.js';
import createPdf from './base.js';
import { logo_pdf } from 'assets/img/logo-pdf.js'


const diagnosticoPDF = async (output, { paciente, listaItemsLaboratorio }) => {



  let data = []


  for (let d of listaItemsLaboratorio) {
    if (d.item == 1 || d.item == 2) {

      data.push([
        {
          margin: [0, 5, 0, 0],
          table: {
            widths: ['28%', '20%', '22%'],
            body: [
              [
                { text: 'PRUEBA', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },
                { text: 'RESULTADO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },
                { text: '', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },

              ],
              [
                { text: d.items_diagnostico, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
                { text: d.m_resultado, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
                { text: d.m_num_micrometodo, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
              ],
            ],
          },
          // 
          layout: 'noBorders'
        },
      ]
      )
    }

    if (d.item == 3) {

      data.push([
        {
          margin: [0, 5, 0, 0],
          table: {
            widths: ['22%', '50%'],
            body: [
              [
                { text: 'PRUEBA', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5, },
                { text: 'RESULTADO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5, },

              ],
              [
                { text: d.items_diagnostico, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
                { text: d.i_resultado, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
              ],
            ],
          },
          // 
          layout: 'noBorders'
        },
      ]
      )
    }

    if (d.item == 4) {

      data.push([
        {
          margin: [0, 5, 0, 0],
          table: {
            widths: ['28%', '32%', '20%', '20%'],
            body: [
              [
                { text: 'PRUEBA', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },
                { text: 'DILUSION', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },
                { text: 'LINEA DE CORTE', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },
                { text: 'RESULTADO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },

              ],
              [
                { text: d.items_diagnostico, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
                { text: d.h_dilusion, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
                { text: d.h_linea_de_corte, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
                { text: d.h_resultado, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
              ],
            ],
          },
          // 
          layout: 'noBorders'
        },
      ]
      )
    }


    if (d.item == 5 || d.item == 7) {

      data.push([
        {
          margin: [0, 5, 0, 0],
          table: {
            widths: ['28%', '32%', '20%', '20%'],
            body: [
              [
                { text: 'PRUEBA', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },
                { text: 'D.O.', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },
                { text: 'CUT - OFF', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },
                { text: 'RESULTADO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },

              ],
              [
                { text: d.items_diagnostico, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
                { text: d.e_do, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
                { text: d.e_cut_off, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
                { text: d.e_resultado, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
              ],
            ],
          },
          // 
          layout: 'noBorders'
        },
      ]
      )
    }

    if (d.item == 9) {

      data.push([
        {
          margin: [0, 5, 0, 0],
          table: {
            widths: ['28%', '32%', '20%', '20%'],
            body: [
              [
                { text: 'PRUEBA', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },
                { text: 'TITULO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },
                { text: 'CUT - OFF', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },
                { text: 'RESULTADO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 5 },

              ],
              [
                { text: d.items_diagnostico, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
                { text: d.ifi_titulo, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
                { text: d.ifi_cut_of, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
                { text: d.ifi_resultado, style: 'subtitulo', alignment: 'left', fontSize: 7, margin: [0, 0, 0, 0], fillColor: '#eaeded' },
              ],
            ],
          },
          // 
          layout: 'noBorders'
        },
      ]
      )
    }
  }



  let titulo = 'DIAGNOSTICOS PARA CHAGAS'
  let subtitulo = 'RESULTADOS '

  const content = [
    {
      margin: [0, 0, 0, 0],
      table: {
        widths: ['30%', '50%', '20%'],
        body: [
          [
            {
              image: logo_pdf,
              fit: [130.73, 60.692],
              alignment: 'left',
              margin: [0, 0, 0]
            },
            { text: titulo, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fontSize: 14 },
            { text: 'CODIGO                ', style: 'header', alignment: 'left', margin: [2, 5, 0, 0], fontSize: 10 },
          ],
          [
            {},
            { text: subtitulo, style: 'titulo', alignment: 'center', },
            { text: 'N°' + listaItemsLaboratorio[0]?.codigo, style: 'text', alignment: 'rigth', margin: [3, 0, 0, 10], color: 'red', fontSize: 9 },
          ],
        ],
      },
      layout: 'noBorders',
    },

    //TIPO Y NUMERO DOCUMENTO


    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '1. SOLICITUD', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },
    {
      margin: [0, 0, 0, 0],

      table: {
        widths: ['16%', '12%', '18%', '18%', '18%', '20%',],
        body: [
          [
            { text: 'Fecha solicitud', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'MEDICO', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'SEDES', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Coordenacion de Red', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Municipio', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Est. de salud', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded' },

          ],
          [
            { text: listaItemsLaboratorio[0]?.fecha_solicitud.split('T')[0], style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], },
            { text: listaItemsLaboratorio[0]?.medico_solicitante, style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fontSize: 6, },
            { text: 'CHUQUISACA', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0] },
            { text: listaItemsLaboratorio[0]?.red_hospital, style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0] },
            { text: listaItemsLaboratorio[0]?.municipio_hospital, style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0] },
            { text: listaItemsLaboratorio[0]?.hospital, style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], },
          ],

        ],
      },

      layout: 'noBorders'







      // layout: {
      //   hLineColor: function (i, node) {
      //     return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
      //   },
      //   vLineColor: function (i, node) {
      //     return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
      //   },

      // }


    },

    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '2. DATOS DEL PACIENTE', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },

    {
      margin: [0, 0, 0, 0],

      table: {
        widths: ['12%', '16%', '16%', '20%', '12%', '8%', '10%', '8%'],
        body: [
          [
            { text: 'Cedula de identidad', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded', fontSize: '6' },
            { text: 'Nombre', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded', fontSize: '6' },
            { text: 'Apelido paterno', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded', fontSize: '6' },
            { text: 'Apellido materno', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded', fontSize: '6' },
            { text: 'sexo', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded', fontSize: '6' },
            { text: 'edad años', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded', fontSize: '6' },
            { text: 'edad meses', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded', fontSize: '6' },
            { text: 'edad dias', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded', fontSize: '6' },

          ],
          [
            { text: paciente[0].ci ? paciente[0].ci : 'TUTOR: ' + paciente[0].ci_tutor, style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], },
            { text: paciente[0].nombre, style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], },
            { text: paciente[0].ap1, style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], },
            { text: paciente[0].ap2 ? paciente[0].ap2 : null, style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0] },
            { text: paciente[0].sexo == 1 ? 'MASCULINO' : paciente[0].sexo == 2 ? 'FEMENINO' : '-', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0] },
            { text: listaItemsLaboratorio[0].edad_años, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
            { text: listaItemsLaboratorio[0].edad_meses, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
            { text: listaItemsLaboratorio[0].edad_dias, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },


          ],

        ],
      },
      layout: 'noBorders'

    },




    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '3. EXÁMENES DE LABORATORIO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },



    {
      table: {
        widths: ['70%', '32%',],
        body: [

          [
            { text: 'TIPO DE MUESTRA', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded', fontSize: '6' },
            { text: 'FECHA TOMA DE MUESTRA', style: 'subtitulo', alignment: 'left', margin: [2, 5, 0, 0], fillColor: '#eaeded', fontSize: '6' },

          ],
          [
            { text: listaItemsLaboratorio[0].tipo_de_muestra === 0 ? '-' : listaItemsLaboratorio[0].tipo_de_muestra === 1 ? 'SANGRE TOTAL' : listaItemsLaboratorio[0].tipo_de_muestra === 2 ? 'SUERO' : listaItemsLaboratorio[0].tipo_de_muestra === 3 ? 'PLASMA' : listaItemsLaboratorio[0].tipo_de_muestra === 4 ? 'LCR' : null, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], },

            { text: listaItemsLaboratorio[0].fecha_toma_muestra, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0] },
          ],
        ],
      },

      layout: 'noBorders'

    },



    {
      margin: [0, 0, 0, 0],

      table: {
        widths: ['102%'],
        body: data
      },
      layout: 'noBorders'
    },


    { text: listaItemsLaboratorio[0].conclusion ? ' CONCLUSION DIAGNOSTICA: ' + listaItemsLaboratorio[0].conclusion : 'CONCLUSION DIAGNOSTICA:______________________________________________________________________________________________________________________________________________________', style: 'subtitulo', margin: [0, 10, 0, 0], fontSize: 7, alignment: 'left' },
    { text: listaItemsLaboratorio[0].observaciones ? ' Observaciones : ' + listaItemsLaboratorio[0].observaciones : 'Observaciones : ________________________________________________________________________________________________________________________________________________', style: 'subtitulo', margin: [0, 10, 0, 10], fontSize: 7, alignment: 'left' },











    {
      table: {
        widths: ['102%'],  
        body: [
          [
            { text: '4. LABORATORISTA', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },

    {
      table: {
        widths: ['25%', '45%', '15%', '17%'],
        body: [
          [
            { text: 'Nombres y apellidos', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#eaeded', },
            { text: 'Laboratorio', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0],fillColor: '#eaeded',  },
            { text: ' Teléfono / celular', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#eaeded', },
            { text: ' Firma y sello', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#eaeded', },
          ],
          [
            { text: listaItemsLaboratorio[0].medico_laboratorio, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: listaItemsLaboratorio[0].laboratorio, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: listaItemsLaboratorio[0].celular, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ' ', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
          ],
        ],
      },

      layout: 'noBorders'

    },

    { text: '__________________________________________________________________________', style: 'piePagina', alignment: 'center', margin: [0, 50, 0, 0], },
    { text: 'PROFESIONAL MEDICO', style: 'piePagina', alignment: 'center', fontSize:'6'},
    { text: localStorage.getItem('nombre'), style: 'subtitulo', alignment: 'center', },

  ];

  const response = await createPdf({ content }, output);
  return response;
};

export { diagnosticoPDF };
